//
//
//
import { request } from '@/api/service';
export default {
  name: 'd2-span',
  props: {
    // 值
    value: {
      type: String,
      required: false,
      default: function _default() {
        return '';
      }
    }
  },
  watch: {
    value: {
      handler: function handler(value) {
        this.value = value;
      },
      immediate: true
    }
  },
  created: function created() {
    var _this = this;

    request({
      method: 'post',
      url: '/api/sms-market/index',
      data: {}
    }).then(function (res) {
      console.log(res.list[0].rest);
      _this.value = res.list[0].rest;
    });
  },
  methods: {
    onValueChange: function onValueChange() {
      this.$emit('change');
    }
  }
};